import { getStateStore } from '../../stores';
import { getIpcFunctions } from '../ipcInterface';

export const initializeQueueEvents = () => {
  const state = getStateStore('ipc');
  let cachedPendingPlayers = state.queueState.currentState.knocks.pendingPlayers;
  state.queueState.addListener((queueState) => {
    const cachedUniqueIds = Object.keys(state.knockMetadataState.currentState.metadata);
    // console.log('Queue:', queueState);
    const uniqueIds: { [key: string]: boolean } = {};
    queueState.knocks.acceptedPlayers.forEach((knock) => {
      uniqueIds[knock] = true;
    });
    queueState.knocks.pendingPlayers.forEach((knock) => {
      uniqueIds[knock] = true;
    });
    queueState.knocks.rejectedPlayers.forEach((knock) => {
      uniqueIds[knock] = true;
    });
    const added = Object.keys(uniqueIds).filter((uniqueId) => !cachedUniqueIds.includes(uniqueId));
    const removed = cachedUniqueIds.filter((uniqueId) => !uniqueIds[uniqueId]);

    added.forEach(async (uniqueId) => {
      state.knockMetadataState.currentState.metadata[uniqueId] = {
        pending: true,
        name: '',
        playCount: 0,
        timestamp: Date.now(),
        acceptedTimestamp: Date.now(),
      };
      // setTimeout(() => {
      //   getKnockInfo(uniqueId).then((knockInfo) => {
      //     if (knockInfo) {
      //       const isoStr = knockInfo.createdTimestamp;
      //       const acceptedIsoString = knockInfo.acceptedTimestamp ?? isoStr;
      //       const createdTime = new Date(isoStr);
      //       const joinedTime = new Date(acceptedIsoString);

      //       // ensure the name is unique, if not add (2), (3), etc to the end
      //       let name = knockInfo.name;
      //       let i = 2;
      //       // eslint-disable-next-line no-loop-func
      //       while (Object.values(state.knockMetadataState.currentState.metadata).find((m) => m.name === name)) {
      //         name = `${knockInfo.name} (${i})`;
      //         i++;
      //       }

      //       state.knockMetadataState.currentState.metadata[uniqueId] = {
      //         pending: false,
      //         name,
      //         playCount: knockInfo.timesUsed,
      //         timestamp: createdTime.getTime(),
      //         acceptedTimestamp: joinedTime.getTime(),
      //       };
      //       state.knockMetadataState.updateState({
      //         metadata: { ...state.knockMetadataState.currentState.metadata },
      //       });
      //     } else {
      //       delete state.knockMetadataState.currentState.metadata[uniqueId];
      //       state.knockMetadataState.updateState({
      //         metadata: { ...state.knockMetadataState.currentState.metadata },
      //       });
      //     }
      //   });
      // }, 500);
    });
    removed.forEach((uniqueId) => {
      delete state.knockMetadataState.currentState.metadata[uniqueId];
    });
    state.knockMetadataState.updateState({
      metadata: { ...state.knockMetadataState.currentState.metadata },
    });

    if (state.hostState.currentState.status === 'streaming') {
      const playersChanged = queueState.knocks.pendingPlayers.some((playerId) => !cachedPendingPlayers.includes(playerId));
      const spaceAvailable =
        queueState.settings.maxPlayers === -1 || queueState.knocks.acceptedPlayers.length < (queueState.settings.maxPlayers ?? 0);
      if (spaceAvailable || playersChanged) {
        cachedPendingPlayers = queueState.knocks.pendingPlayers;
        // check whether we should accept new players.
        let pendingPlayers = queueState.knocks.pendingPlayers.map((playerId) => {
          const md = state.knockMetadataState.currentState.metadata[playerId];
          return {
            playerId,
            isWaiting: false,
            name: md?.name ?? '',
            playCount: md?.playCount ?? 0,
          };
        });
        if (queueState.settings.prioritizeNewPlayers) {
          pendingPlayers.sort((a, b) => a.playCount - b.playCount);
        }
        pendingPlayers = pendingPlayers.filter(
          (player) =>
            !queueState.knocks.acceptedPlayers.includes(player.playerId) && !queueState.knocks.rejectedPlayers.includes(player.playerId),
        );
        let playersToAccept: typeof pendingPlayers = [];
        if (state.hostRuleState.currentState.hostHandlesQueueAccepting && state.hostRuleState.currentState.hostAutoAccept) {
          const maxPlayers = queueState.settings.maxPlayers ?? -1;
          const currentlyTakenSlots = queueState.knocks.acceptedPlayers.length + Object.keys(state.playerState.currentState.players).length;
          if (currentlyTakenSlots < maxPlayers || maxPlayers === -1) {
            const availableSlots = maxPlayers === -1 ? pendingPlayers.length : maxPlayers - currentlyTakenSlots;
            playersToAccept = pendingPlayers.slice(0, availableSlots);
            pendingPlayers = pendingPlayers.filter((player) => !playersToAccept.includes(player));
          }
        }
        if (playersToAccept.length > 0) {
          const ipcFunctions = getIpcFunctions();
          playersToAccept.forEach((player) => ipcFunctions.acceptKnock(player.playerId));
        }
      }
    }
    cachedPendingPlayers = queueState.knocks.pendingPlayers;
  });
};
